import { type FormMetadata } from '@conform-to/react';
import { useEffect } from 'react';
import { toast } from 'sonner';
import { useEditableTranslation } from '#common/i18n/edit-mode.tsx';

export function useFormGlobalErrorToast(form: FormMetadata<any> | undefined) {
    const { t } = useEditableTranslation([ 'common' ]);

    useEffect(() => {
        if (form?.allErrors[''] && form.allErrors[''].length > 0) {
            toast.error(t('common:errors.somethingWentWrong'));
        }
    }, [ form?.allErrors ]);
}
